const getters = {
  cartData: state => state.cart.data
}
export default getters
